import { withInstall } from '@/utils'
import CosModal from './src/cosModal.vue'
export default withInstall(CosModal)
